import { SidebarLayout } from './Components/Catalyst/sidebar-layout';
import { Navbar } from './Components/Catalyst/navbar';
import { Heading, Subheading } from './Components/Catalyst/heading';
import { Divider } from './Components/Catalyst/divider';
import AppSidebar from './AppSidebar';
import ViolationList from './Violations/ViolationList';
import LoadingSpinner from './LoadingSpinner';
import NotificationList from './Notifications/NotificationList';
import HomeSelector from './Components/Custom/HomeSelector';
import { ErrorAlert } from './Components/Custom/ErrorAlert';
import { useMember } from './Hooks/MemberContext';
import AccountBalanceCard from './Account/AccountBalanceCard';
import UpcomingReservationsCard from './Reservations/UpcomingReservationsCard';

interface DashboardProps {
  currentPage: string;
}

const Dashboard: React.FC<DashboardProps> = ({ currentPage }) => {
  // Previously this gated on `getMemberIdFromToken()`, which parsed
  // `mbr_abc123` with `parseInt` and got `NaN` — so the spinner never
  // went away. The real load state is the profile fetch.
  const { displayName, loading, error, homes, reload } = useMember();

  if (loading) {
    return <LoadingSpinner />;
  }

  return (
    <SidebarLayout
      sidebar={<AppSidebar currentPage={currentPage} />}
      navbar={<Navbar>{/* Your navbar content */}</Navbar>}
    >
      <Heading>
        Welcome To Your Portal{displayName ? `, ${displayName}` : ''}!
      </Heading>

      {error ? (
        <ErrorAlert className="mt-2" onRetry={reload}>
          {error}
        </ErrorAlert>
      ) : homes.length === 0 ? (
        <Subheading>
          Your account is not linked to a home yet. Please contact your
          association manager.
        </Subheading>
      ) : (
        <HomeSelector />
      )}

      <Divider className="mt-4 mb-6"></Divider>

      {/* What a homeowner signs in to find out. Renders nothing until
          it has a real figure, so a slow or failed balance never
          delays the rest of the dashboard. */}
      {homes.length > 0 && (
        <div className="mb-6">
          <AccountBalanceCard />
        </div>
      )}

      {homes.length > 0 && (
        <div className="mb-6">
          <UpcomingReservationsCard />
        </div>
      )}

      <ViolationList></ViolationList>

      <Divider className="mt-4 mb-6"></Divider>

      <NotificationList></NotificationList>
    </SidebarLayout>
  );
};

export default Dashboard;
